export function sanitizedHTMLFragment(htmlString) {
  const parser = new DOMParser()
  const parsed = parser.parseFromString(htmlString, "text/html")
  return parsed.body.children
}
